var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"pinpoll-image",style:({ 'background-image': 'url(' + _vm.src + ')', height: _vm.height })})])}
var staticRenderFns = []

export { render, staticRenderFns }